import { render, staticRenderFns } from "./DecoratorProperty.vue?vue&type=template&id=22dcd2b9&scoped=true&"
import script from "./DecoratorProperty.vue?vue&type=script&lang=js&"
export * from "./DecoratorProperty.vue?vue&type=script&lang=js&"
import style0 from "./DecoratorProperty.vue?vue&type=style&index=0&id=22dcd2b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcd2b9",
  null
  
)

export default component.exports